module.exports = __webpack_public_path__ + "media/assets/images/car_icon_gaisya-3070c49576491abe5d0673a9e3248707.png";